import { Navigate, Outlet } from 'react-router-dom'
import { FullPageSpinner } from '@/components/ui/loading-spinner'
import { useBillingStatus } from '@/hooks/use-billing-status'

/**
 * Protege rotas do módulo financeiro exigindo que o billing esteja configurado.
 * Se não estiver configurado, redireciona para o onboarding em /configuracoes?tab=financeiro.
 */
export function BillingConfigRoute() {
  const { isConfigured, isLoading } = useBillingStatus()

  if (isLoading) {
    return <FullPageSpinner minHeight='min-h-[50vh]' />
  }

  if (!isConfigured) {
    return <Navigate to='/configuracoes?tab=financeiro' replace />
  }

  return <Outlet />
}
